<template>
  <b-dropdown
    ref="dropdown"
    v-bind="$attrs"
    v-on="$listeners"
    boundary="window"
    no-flip
    v-b-tooltip="tooltip"
  >
    <template #button-content>
      <slot name="button-content">
        {{text}}
      </slot>
    </template>

    <b-dropdown-form>
      <div class="d-flex align-items-center justify-content-between gap-2">
        <b-form-checkbox
          :checked="selectAll"
          @change="selectAll = $event"
        >Select All</b-form-checkbox>
        <slot name="extra"></slot>
      </div>
    </b-dropdown-form>
    <b-dropdown-divider/>
    <b-dropdown-form>
      <b-form-checkbox-group
        :checked="columns_"
        @change="columns_ = $event"
        :options="options"
        stacked
      />
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import BDropdownCustom from '@/components/BDropdownCustom.vue'

export default {
  name: 'ColumnPicker',
  components: {
    BDropdown: BDropdownCustom,
  },
  inheritAttrs: false,
  props: {
    value: String,
    options: Array,
    text: null,
    tooltip: null,
  },
  computed: {
    columns_: {
      get() {
        return this.value ? this.value.split(',') : []
      },
      set(val) {
        this.$emit('input', val?.join(','))
      },
    },
    options_() {
      return this.options?.map(i => i.value ?? i)
    },
    selectAll: {
      get() {
        const { columns_, options_ } = this
        return columns_.length >= options_?.length
          && new Set([...columns_, ...options_]).size === columns_.length
      },
      set(val) {
        if (val) {
          this.columns_ = this.options_
        } else {
          this.columns_ = undefined // reset to default columns
        }
      },
    },
  },
}
</script>
